export const difficultiesMap = {
        "1": "Fácil",
        "2": "Médio",
        "3": "Difícil",
};


